// Karta kontaktu (mockup v8, obrazovka 2): proč se dnes volá, Zavolat, jak dopadl hovor,
// dotazník, cíl a zdraví, poznámky (jako komentáře u klientky) a historie se štítky.
import React, { useCallback, useEffect, useState } from "react";
import {
  Users, Phone, Copy, Mail, PhoneIncoming, PhoneMissed, CalendarClock, UserX, CalendarDays, NotebookPen, MessageSquare,
  CalendarPlus, CircleX, PhoneForwarded, CircleCheck, UserRound, Download, UserPlus, RotateCcw, ChevronLeft, CalendarCheck, Pencil, Receipt, Trash2, X, UserMinus, Archive,
} from "lucide-react";
import KomentareKontaktu from "./KomentareKontaktu.jsx";
import { NabidkaAkci } from "../ui.jsx";
import { toast } from "../Toast.jsx";
import { useUzkaObrazovka } from "../../lib/obrazovka.js";
import { salesGet, salesPost, kdyText, kdyUdalost, dm, dmr, casBezNuly, telefonHezky, denKratce } from "./salesApi.js";
import { Pil, SkupinaNadpis, DotTile, Oznameni, StavPilulka } from "./salesUi.jsx";
import { NezvedlaDialog, JindyDialog, NezajemDialog, OpravitJmenoDialog, DotaznikDialog } from "./Dialogy.jsx";
import HovorPruvodce from "./HovorPruvodce.jsx";
import NavratDialog from "./NavratDialog.jsx";
import SpolupraceKlientky from "./SpolupraceKlientky.jsx";
import ZalozitKlientku from "./ZalozitKlientku.jsx";
import VysledekLeadu from "./VysledekLeadu.jsx";
import { NeuzavrenoEmailBlok } from "../Rozlouceni.jsx";
import { ZkusebniBanner, PresunDialog, ZrusitDialog, FakturaDialog } from "./ZkusebniDialogy.jsx";
import { confirmDialog } from "../confirmHost.jsx";
import { LeadNejdeSmazatDialog, SmazatTestovaciDialog } from "./SmazatTestovaciDialog.jsx";
import { NedorazilaDialog } from "../deal/DealDialogy.jsx";
import { getCurrentUser } from "../../lib/auth.js";
import { apiFetch } from "../../lib/api.js";

const IKONY = {
  sms: [MessageSquare, "bg-sky-50 text-sky-700"], nezvedla: [PhoneMissed, "bg-amber-50 text-amber-700"], zvedla: [PhoneIncoming, "bg-emerald-50 text-emerald-700"],
  jindy: [CalendarClock, "bg-brand-100 text-brand-deep"], nezajem: [UserX, "bg-slate-100 text-slate-600"], uzavreno: [UserX, "bg-slate-100 text-slate-600"],
  zkusebni: [CalendarPlus, "bg-emerald-50 text-emerald-700"], presun: [CalendarClock, "bg-brand-100 text-brand-deep"], zruseno: [CircleX, "bg-rose-50 text-rose-700"],
  poznamka: [NotebookPen, "bg-slate-100 text-slate-600"], email: [Mail, "bg-slate-100 text-slate-600"], k_volani: [PhoneForwarded, "bg-brand-100 text-brand-deep"],
  klientka: [CircleCheck, "bg-emerald-50 text-emerald-700"], prevzato: [Download, "bg-slate-100 text-slate-600"], novy: [UserPlus, "bg-brand-100 text-brand-deep"],
  neuzavreno: [UserX, "bg-amber-50 text-amber-700"], nedorazila: [UserMinus, "bg-amber-50 text-amber-700"], prohra: [CircleX, "bg-rose-50 text-rose-700"], navrat: [CircleCheck, "bg-emerald-50 text-emerald-700"], prejmenovani: [Pencil, "bg-slate-100 text-slate-600"],
};
function textUdalosti(h) {
  if (h.typ === "sms") {
    if (h.meta?.typ === "uvitaci") return "Uvítací SMS odeslána";
    const druh = { ranni: "Ranní SMS: dnes po 16:00 vám zavoláme", po_nezvednuti: "SMS po nezvednutí odeslána", zaverecna: "Závěrečná SMS odeslána", test: "Testovací SMS" }[h.meta?.typ];
    return `${druh || "SMS odeslána"}${h.meta?.ok === false ? `, NEODEŠLA (${h.meta?.chyba || "chyba"})` : ""}`;
  }
  return h.text;
}

function Udalost({ h }) {
  const [Ikona, c] = IKONY[h.typ] || [NotebookPen, "bg-slate-100 text-slate-600"];
  const k = kdyUdalost(h.kdy);
  return (
    <div className="flex gap-3">
      <span className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-full ${c}`}><Ikona className="h-4 w-4" /></span>
      <div className="min-w-0 flex-1 space-y-1.5 pt-0.5">
        <div className="text-[15px] font-semibold leading-snug text-slate-900 [overflow-wrap:anywhere]">{textUdalosti(h)}</div>
        <div className="flex flex-wrap gap-1.5"><Pil ton="neutralni" casti={[k.den, k.cas, h.kdo ? String(h.kdo).split(" ")[0] : ""]} /></div>
      </div>
    </div>
  );
}

// 20. 10. 2026 (Láďa, mockup 1/3): zaplatila zkušební kartou až po vypršení držení a termín
// obsadil někdo jiný. Sales s ní vybere nový termín přes její osobní odkaz (nic neplatí,
// faktura se znovu nevystavuje), dotazník jde upravit tady.
function ZaplacenoBezTerminu({ z, onVybrat, onDotaznik }) {
  return (
    <div className="space-y-3 rounded-2xl border-2 border-emerald-300 bg-emerald-50 p-3 sm:p-4">
      <div className="flex items-center gap-2.5">
        <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-emerald-600 text-white"><CalendarPlus className="h-5 w-5" /></span>
        <div className="text-[16px] font-bold leading-snug text-emerald-950">Zaplaceno, vyber s ní nový termín</div>
      </div>
      <div className="flex flex-wrap gap-1.5">
        <Pil ton="ok" ikona={CircleCheck} casti={["Zkušební zaplacen kartou", z.zaplaceno ? dm(z.zaplaceno) : null].filter(Boolean)} />
        {(z.castka || z.faktura) && <Pil ton="neutralni" casti={[z.castka ? `${Number(z.castka).toLocaleString("cs-CZ")} Kč` : null, z.faktura ? `faktura ${z.faktura}` : null].filter(Boolean)} />}
        <Pil ton="pozor" ikona={CalendarClock} casti={["termín nevybraný", `${z.dni} ${z.dni === 1 ? "den" : z.dni >= 2 && z.dni <= 4 ? "dny" : "dní"}`]} />
      </div>
      <div className="text-[14px] leading-snug text-emerald-950">Zaplatila po vypršení držení a termín mezitím obsadil někdo jiný. {z.po_lhute ? "Sama si nový nevybrala. " : "Odkaz na výběr dostala e‑mailem. "}Zavolej jí a vyber s ní nový termín. <b>Novou fakturu nevystavuj.</b></div>
      <div className="grid gap-2 sm:grid-cols-[1fr_auto]">
        <button type="button" className="btn w-full bg-emerald-600 !min-h-[56px] !text-base text-white hover:bg-emerald-700 disabled:opacity-60 sm:!min-h-[48px]" onClick={onVybrat} disabled={!z.odkaz}><CalendarPlus className="h-5 w-5" />Vybrat termín s klientkou</button>
        <button type="button" className="btn-secondary w-full !min-h-[52px] sm:!min-h-[48px]" onClick={onDotaznik}><Pencil className="h-4 w-4" />Upravit dotazník</button>
      </div>
    </div>
  );
}

// 3. 11. 2026 (Láďa): archivovaný kontakt (k.archiv ze serveru podle sales_info.archiv, ne podle
// stage). Kdy a kdo v pilulkách, owner ho vrátí tlačítkem Vrátit z archivu.
function ArchivBlok({ k, onVratit, prace }) {
  const a = k.archiv || {};
  const kdy = a.kdy ? kdyUdalost(a.kdy) : null;
  return (
    <div className="space-y-3 rounded-2xl border-2 border-slate-300 bg-slate-50 p-3 sm:p-4">
      <div className="flex items-center gap-2.5">
        <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-slate-700 text-white"><Archive className="h-5 w-5" /></span>
        <div className="text-[16px] font-bold leading-snug text-slate-900">Archivováno</div>
      </div>
      <div className="flex flex-wrap gap-1.5">
        {kdy && <Pil ton="neutralni" ikona={CalendarDays} casti={[kdy.den, kdy.cas]} />}
        {a.kdo && <Pil ton="neutralni" ikona={UserRound} casti={[String(a.kdo).split(" ")[0]]} />}
        {a.klientka && <Pil ton="ok" ikona={CircleCheck} casti={["Deal, zůstává klientkou"]} />}
      </div>
      <div className="text-[14px] leading-snug text-slate-700">
        {a.klientka
          ? "Kontakt není v přehledech leadů. Klientka i její karta zůstávají beze změny a ve statistikách sales se dál počítá."
          : "Kontakt není v plánu volání ani v přehledech leadů. Historie a vazby zůstaly."}
        {onVratit ? (a.klientka ? " Vrácením se zase ukáže v Leadech jako Deal." : " Vrácením se kontakt vrátí do dnešního plánu hovorů.") : ""}
      </div>
      {onVratit && (
        <button type="button" className="btn-primary w-full !min-h-[52px] sm:w-auto sm:!min-h-[44px]" onClick={onVratit} disabled={prace}>
          <RotateCcw className="h-4 w-4" />Vrátit z archivu
        </button>
      )}
    </div>
  );
}

function Banner({ k }) {
  // Nedorazila na zkušební má vlastní pruh níž (22. 10. 2026).
  if (k.nedorazila) return null;
  const z = (k.zkusebni || []).find((x) => x.stav === "aktivni");
  if (k.stav === "zkusebni" && z) {
    return (
      <div className="space-y-2">
        <ZkusebniBanner z={z} />
        <Oznameni ton="ok" ikona={CalendarCheck}><b>Zkušební trénink {denKratce(z.datum)} v {casBezNuly(z.cas)}</b>, trenér {z.trener}. Faktura {z.faktura || "chybí"}, {z.platba.text}.</Oznameni>
      </div>
    );
  }
  // 19. 10. 2026: 2. kolo, v 1. kole ani jednou nezvedla.
  if (k.druhe_kolo && ["odlozeno", "novy", "pokus"].includes(k.stav)) {
    const d = k.druhe_kolo;
    const n = k.stav === "pokus" ? k.pokus + 1 : 1;
    return <Oznameni ton="info" ikona={PhoneMissed}><b>2. kolo, {n}. pokus ze 2{k.stav === "odlozeno" && k.dalsi ? `, hovor ${kdyText(k.dalsi)}` : ""}.</b> V 1. kole ({dm(d.kolo1)}) nezvedla ani na jeden ze {d.pokusu} pokusů. {n >= 2 ? "Když nezvedne ani teď, uzavře se jako NQlead." : "Když nezvedne, pošle se jí SMS a další hovor bude za týden."}</Oznameni>;
  }
  if (k.stav === "odlozeno") return <Oznameni ton="znacka" ikona={CalendarClock}><b>Domluveno zavolat {kdyText(k.dalsi)}{k.dalsi_cas ? ` v ${casBezNuly(k.dalsi_cas)}` : ""}.</b>{k.poznamka ? ` ${k.poznamka}` : ""}</Oznameni>;
  if (k.stav === "doplnit") return <Oznameni ton="pozor"><b>Doplnit datum.</b> {k.poznamka || "Převzato z Notionu bez data dalšího hovoru."}</Oznameni>;
  // 15. 10. 2026: typ kontaktu řídí SMS a počet pokusů (salesAkce.typKontaktu).
  const jeNovy = !k.typ || k.typ === "novy";
  const maxPokusu = jeNovy ? 4 : 3;
  if (k.typ === "aktivni" && !["klientka"].includes(k.stav)) return <Oznameni ton="ok" ikona={CircleCheck}><b>Je aktivní klientka, volá jí trenér.</b> Zavolat jí můžeš, automatické SMS se neposílají.{k.poznamka ? ` ${k.poznamka}` : ""}</Oznameni>;
  // 19. 10. 2026: po zkušebním nezačala. Vrací se po 3 měsících, nebo jí sales má nabídnout jiného
  // trenéra. Musí být před větvemi pro pokus, jinak by se pruh u druhého pokusu nezobrazil.
  if (k.po_zkusebnim?.typ === "pozdeji" && ["novy", "pokus"].includes(k.stav)) {
    const p = k.po_zkusebnim;
    return <Oznameni ton="pozor" ikona={UserRound}><b>Vrací se po 3 měsících.</b> Po zkušebním tréninku nezačala{p.duvod_text ? `: ${p.duvod_text.toLowerCase()}` : ""}. Trenér {p.trener}{p.zkusebni ? `, zkušební ${dm(p.zkusebni)}` : "."} {p.poznamka ? `Trenér napsal: „${p.poznamka}“ ` : ""}Cílem hovoru je zjistit, jestli to teď půjde, klidně u jiného trenéra. Zná nás, SMS se jí neposílají.{k.stav === "pokus" ? ` ${k.pokus + 1}. pokus.` : ""}</Oznameni>;
  }
  if (k.po_zkusebnim && ["novy", "pokus"].includes(k.stav)) {
    const p = k.po_zkusebnim;
    return <Oznameni ton="pozor" ikona={UserRound}><b>Po zkušebním tréninku nezačala{p.duvod_text ? `: ${p.duvod_text.toLowerCase()}` : ""}.</b> Trenér {p.trener}{p.zkusebni ? `, zkušební ${dm(p.zkusebni)}` : "."} {p.poznamka ? `Trenér napsal: „${p.poznamka}“ ` : ""}Cílem hovoru je nabídnout jiného trenéra{p.duvod === "cas" ? " s časem, který jí vyhovuje" : ""}. Zná nás, SMS se jí neposílají.{k.stav === "pokus" ? ` ${k.pokus + 1}. pokus.` : ""}</Oznameni>;
  }
  if (k.stav === "pokus" && !jeNovy) {
    const n = k.pokus + 1;
    return <Oznameni ton="pozor" ikona={PhoneMissed}><b>{kdyText(k.dalsi) === "dnes" ? "Dnes" : `${kdyText(k.dalsi)}:`} {n}. pokus ze {maxPokusu}.</b> {k.typ === "byvala" ? "Bývalá klientka, SMS se neposílají." : "Byla na zkušebním, SMS se neposílají."}{n >= maxPokusu ? (k.typ === "byvala" ? " Když nezvedne, vrátí se mezi Bývalé." : " Když nezvedne, zkusí se znovu za 3 měsíce.") : ""}</Oznameni>;
  }
  if (k.stav === "pokus") {
    const n = k.pokus + 1;
    if (n >= 4) return <Oznameni ton="problem" ikona={PhoneMissed}><b>Poslední pokus.</b> Když nezvedne, kontakt se uzavře.</Oznameni>;
    return <Oznameni ton="pozor" ikona={PhoneMissed}><b>{kdyText(k.dalsi) === "dnes" ? "Dnes" : `${kdyText(k.dalsi)}:`} {n}. pokus ze 4.</b> {n === 3 ? "Když nezvedne, pošle se závěrečná SMS." : "Když nezvedne, další hovor za týden."}</Oznameni>;
  }
  // 1. 10. 2026: nový kontakt přijde bez data, první hovor naplánuje sales sama.
  if (k.stav === "novy" && !k.byvala && !jeNovy) return <Oznameni ton="info" ikona={CalendarClock}><b>Byla na zkušebním tréninku.</b> {k.dalsi ? `Hovor ${kdyText(k.dalsi)}${k.dalsi_cas ? ` kolem ${casBezNuly(k.dalsi_cas)}` : ""}.` : "Naplánuj hovor."} SMS se jí neposílají, zná nás.{k.poznamka ? ` ${k.poznamka}` : ""}</Oznameni>;
  if (k.stav === "novy" && !k.byvala && !k.dalsi) return <Oznameni ton="pozor" ikona={CalendarClock}><b>Naplánuj první hovor.</b> Klepni na Naplánovat hovor a vyber den. V ten den ráno v 9:00 jí systém pošle SMS, že se jí ozveš. Zavolat můžeš i hned.</Oznameni>;
  if (k.stav === "novy" && !k.byvala && k.dalsi) return <Oznameni ton="znacka" ikona={CalendarClock}><b>První hovor {kdyText(k.dalsi)}{k.dalsi_cas ? ` kolem ${casBezNuly(k.dalsi_cas)}` : ""}.</b> {kdyText(k.dalsi) === "dnes" ? "Ráno jí odešla SMS, že se ozveš." : "V ten den ráno v 9:00 jí odejde SMS, že se ozveš."}{k.poznamka ? ` ${k.poznamka}` : ""}</Oznameni>;
  if (k.stav === "novy" && k.byvala && k.po_ukonceni) return <Oznameni ton="pozor"><b>Bývalá klientka, 3 měsíce po ukončení.</b> Cílem hovoru je zjistit, jestli se nechce vrátit.{k.poznamka ? ` ${k.poznamka}` : ""}</Oznameni>;
  if (k.stav === "novy" && k.byvala) return <Oznameni ton="znacka"><b>Bývalá klientka.</b> {k.klientka?.navrat_mozny ? "Cílem hovoru je domluvit návrat, klidně k jinému trenérovi." : "Cílem hovoru je nabídnout jiného trenéra nebo nový zkušební trénink."}{k.poznamka ? ` ${k.poznamka}` : ""}</Oznameni>;
  if (k.stav === "nezajem") return <Oznameni ton="info" ikona={UserX}><b>Uzavřeno jako NQlead</b>{k.duvod_text ? `: ${k.duvod_text.toLowerCase()}` : ""}.</Oznameni>;
  if (k.stav === "neuzavreno") return <Oznameni ton="pozor">Po zkušebním tréninku nezačala. Je v Bývalých klientkách.</Oznameni>;
  if (k.stav === "klientka" && k.navrat) return <Oznameni ton="ok" ikona={CircleCheck}><b>Domluven návrat {dm(k.navrat.datum)}, bez zkušebního.</b> Trenér {k.navrat.trener}{k.navrat.pravidelne ? `, ${k.navrat.pravidelne}` : ""}. Kristina ji dá Aktivní a spustí fakturaci.</Oznameni>;
  if (k.stav === "klientka") return <Oznameni ton="ok" ikona={CircleCheck}><b>Klientka.</b> Po zkušebním zaplatila spolupráci.</Oznameni>;
  if (!k.stav) return <Oznameni ton="info">Kontakt teď není ve frontě k volání{k.stage ? ` (Notion: ${k.stage})` : ""}.</Oznameni>;
  return null;
}

// onZavrit (8. 10. 2026): karta otevřená jako okno nad seznamem (Klienti → Leady), v hlavičce je křížek.
export default function KartaKontaktu({ id, onZmena, onZpet, popisZpet = "Zpět", onZavrit }) {
  const uzka = useUzkaObrazovka();
  const [k, setK] = useState(null);
  const [chyba, setChyba] = useState("");
  const [dialog, setDialog] = useState(null); // nezvedla | jindy | nezajem | hovor | navrat | presun | zrusit | jmeno
  const [zkDialog, setZkDialog] = useState(null); // snímek zkušebního pro přesun a zrušení
  const [smazany, setSmazany] = useState(""); // jméno smazaného leadu (karta zůstane otevřená jen tam, kde není Zpět)
  const [nabidnoutEmail, setNabidnoutEmail] = useState(false); // po prohře se hned otevře email Neuzavřeno (zadání 5)
  const [nejdeSmazat, setNejdeSmazat] = useState(""); // důvod 409 u běžného smazání (#190)

  const nacti = useCallback(async () => {
    try { const d = await salesGet("kontakt", { id }); setK(d); setChyba(""); }
    catch (e) { setChyba(e.message); }
  }, [id]);
  useEffect(() => { setK(null); nacti(); }, [nacti]);

  const hotovo = (r) => { setDialog(null); nacti(); onZmena?.(r); };
  // 23. 10. 2026 (Láďa): po Nedorazila se okno zavře až s novými daty karty, změna je vidět hned.
  const hotovoPoNacteni = async (r) => { await nacti(); setDialog(null); toast("Uloženo.", "success"); onZmena?.(r); };
  // 6. 10. 2026 (Láďa): každá akce, která mění stav, se nejdřív zeptá. U kontaktu se
  // zkušebním říká, že se trénink neruší.
  const kVolani = async () => {
    const zkAkt = (k?.zkusebni || []).find((x) => x.stav === "aktivni" && !x.probehl);
    const ok = await confirmDialog({
      title: `Vrátit ${String(k?.jmeno || "kontakt").split(" ")[0]} k volání?`,
      description: zkAkt
        ? `Má domluvený zkušební trénink ${denKratce(zkAkt.datum)} v ${casBezNuly(zkAkt.cas)} u ${zkAkt.trener}. Vrácením k volání se trénink neruší, kontakt jen přijde do dnešního plánu hovorů.`
        : "Kontakt se vrátí do dnešního plánu hovorů.",
      confirmLabel: "Ano, vrátit k volání", variant: "primary",
    });
    if (!ok) return;
    try { await salesPost("k_volani", { id }); toast("Kontakt je zpátky v Plánu na dnes.", "success"); nacti(); onZmena?.(); }
    catch (e) { toast(e.message, "error"); }
  };
  // 8. 10. 2026 (Láďa, varianta A): owner smaže lead z nabídky „⋯". Server odmítne lead
  // se zkušebním tréninkem, s odměnou sales nebo lead, ze kterého už je klientka.
  const smazat = async () => {
    const ok = await confirmDialog({
      title: `Smazat lead ${k.jmeno}?`,
      description: "Kontakt zmizí z adminu i ze sales sekce. Smaže se i jeho historie hovorů a komentáře. Vrátit to nejde.",
      confirmLabel: "Smazat lead", variant: "danger",
    });
    if (!ok) return;
    try {
      const r = await apiFetch("/api/lead-delete", { method: "POST", body: JSON.stringify({ id }) });
      const j = await r.json().catch(() => ({}));
      if (r.status === 409 && j.blokovano) {
        // 15. 10. 2026 (Láďa): když smazat nejde, nabídne se archivace (historie a vazby zůstanou).
        // 1. 11. 2026 (#190): owner tu má i Smazat testovací kontakt (smaže lead i navázané záznamy).
        setNejdeSmazat(String(j.error || "").replace(/ Místo smazání.*$/, ""));
        return;
      }
      if (!r.ok) throw new Error(j.error || `Chyba ${r.status}`);
      if (String(j.notion || "").startsWith("error")) toast(`Lead ${k.jmeno} je smazaný, ale v Notionu se nearchivoval a může se vrátit.`, "error");
      else toast(`Lead ${k.jmeno} je smazaný.`, "success");
      setSmazany(k.jmeno);
      onZmena?.();
      (onZavrit || onZpet)?.();
    } catch (e) { toast(e.message, "error"); }
  };
  // 3. 11. 2026: onZmena dostane akci a id leadu, přehled Leady ho hned přesune do Archivu.
  // 3. 11. 2026 (Láďa): archivace se vždy nejdřív zeptá. Zrušit nic nezmění (okno Lead nejde smazat zůstane).
  const archivovat = async () => {
    const ok = await confirmDialog({
      title: `Archivovat kontakt ${String(k?.jmeno || "").trim() || "bez jména"}?`,
      description: "Zmizí z plánu volání i ze všech přehledů. Najdeš ho v dlaždici Archiv a jde vrátit tlačítkem Vrátit z archivu.",
      confirmLabel: "Archivovat", variant: "primary",
    });
    if (!ok) return;
    setNejdeSmazat("");
    try {
      const r = await salesPost("archivovat", { id });
      toast(`Lead ${k.jmeno} je archivovaný.`, "success");
      nacti(); onZmena?.({ akce: "archivovat", leadId: Number(id), archiv: r?.archiv || null });
    } catch (e) { toast(e.message, "error"); }
  };
  const [vraci, setVraci] = useState(false);
  const zArchivu = async () => {
    const ok = await confirmDialog({
      title: `Vrátit ${String(k?.jmeno || "kontakt").split(" ")[0]} z archivu?`,
      description: k?.archiv?.klientka ? "Kontakt se zase ukáže v Leadech jako Deal. Klientky se to nijak nedotkne." : "Kontakt se vrátí z archivu do dnešního plánu hovorů.",
      confirmLabel: "Ano, vrátit z archivu", variant: "primary",
    });
    if (!ok) return;
    setVraci(true);
    try {
      await salesPost("z_archivu", { id });
      toast(k?.archiv?.klientka ? "Kontakt je zpátky v Leadech." : "Kontakt je zpátky v Plánu na dnes.", "success");
      nacti(); onZmena?.({ akce: "z_archivu", leadId: Number(id) });
    } catch (e) { toast(e.message, "error"); }
    finally { setVraci(false); }
  };
  const poSmazaniTestovaciho = (j) => {
    setDialog(null);
    if (String(j?.notion || "").startsWith("error")) toast(`Testovací kontakt ${k.jmeno} je smazaný, ale v Notionu se nearchivoval a může se vrátit.`, "error");
    else toast(`Testovací kontakt ${k.jmeno} je smazaný i se vším, co z něj vzniklo.`, "success");
    setSmazany(k.jmeno);
    onZmena?.();
    (onZavrit || onZpet)?.();
  };
  const kopiruj = async () => { try { await navigator.clipboard.writeText(String(k.telefon).replace(/\s/g, "")); toast("Číslo zkopírováno.", "success"); } catch { toast("Číslo se nepodařilo zkopírovat.", "error"); } };

  if (smazany) return <div className="glass p-4"><Oznameni ton="info">Lead {smazany} je smazaný.</Oznameni></div>;
  if (chyba) return <div className="glass p-4"><Oznameni ton="problem">{chyba}</Oznameni></div>;
  if (!k) return <div className="glass space-y-3 p-4">{[0, 1, 2, 3].map((i) => <div key={i} className="h-12 animate-pulse rounded-lg bg-brand-light" />)}</div>;

  const otevreny = ["novy", "pokus", "odlozeno", "doplnit"].includes(k.stav);
  const maVysledek = ["owner", "manager", "csm"].includes(String(getCurrentUser()?.role || "").toLowerCase());
  const jeOwner = String(getCurrentUser()?.role || "").toLowerCase() === "owner";
  const zk = (k.zkusebni || []).find((x) => x.stav === "aktivni");
  const d = k.dotaznik || {};
  const z = k.zdravi || {};
  const zVyplneno = Object.values(z).some((x) => String(x || "").trim());
  const telHref = `tel:${String(k.telefon || "").replace(/[^\d+]/g, "")}`;
  const polozkyMenu = [
    // 22. 10. 2026: nedorazila bez omluvy se vrací k volání tlačítkem Změnit na s omluvou.
    ...(k.archiv && jeOwner ? [{ klic: "z_archivu", popis: "Vrátit z archivu", ikona: RotateCcw, onClick: zArchivu }] : []),
    ...(!k.archiv && !otevreny && k.stav !== "zkusebni" && !k.nedorazila ? [{ klic: "k_volani", popis: "Vrátit k volání", ikona: RotateCcw, onClick: kVolani }] : []),
    ...(otevreny ? [{ klic: "jindy", popis: k.stav === "novy" && !k.pokus ? "Naplánovat hovor" : "Zavolat jindy", ikona: CalendarClock, onClick: () => setDialog("jindy") }, { klic: "nezajem", popis: "Nemá zájem", ikona: UserX, onClick: () => setDialog("nezajem"), nebezpecna: true }] : []),
    ...(k.telefon ? [{ klic: "kopie", popis: "Zkopírovat telefon", ikona: Copy, onClick: kopiruj }] : []),
    ...(jeOwner && !["klientka", "zkusebni"].includes(k.stav) ? [{ klic: "smazat", popis: "Smazat lead", ikona: Trash2, onClick: smazat, nebezpecna: true, oddelit: true }] : []),
    // 1. 11. 2026 (#190): u klientky a zkušebního běžné smazání v nabídce není, owner má rovnou testovací.
    ...(jeOwner && ["klientka", "zkusebni"].includes(k.stav) ? [{ klic: "smazat_test", popis: "Smazat testovací kontakt", ikona: Trash2, onClick: () => setDialog("smazat_test"), nebezpecna: true, oddelit: true }] : []),
  ];

  return (
    <div className="space-y-4">
      {onZpet && <button type="button" className="btn-secondary" onClick={onZpet}><ChevronLeft className="h-4 w-4" />{popisZpet}</button>}
      <div className="glass min-w-0 overflow-hidden p-4 sm:p-5">
        <div className="-mx-4 -mt-4 mb-4 flex items-center justify-between gap-3 bg-gradient-to-r from-brand-950 via-brand-900 to-brand-700 px-4 py-3 text-white sm:-mx-5 sm:-mt-5 sm:mb-5 sm:px-5">
          <div className="flex min-w-0 items-center gap-3">
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-white/20"><Users className="h-5 w-5" /></span>
            <h3 className="min-w-0 font-serif text-lg font-bold leading-tight">{k.jmeno}</h3>
            {k.smi_prejmenovat && (
              <button type="button" onClick={() => setDialog("jmeno")} aria-label="Opravit jméno" title="Opravit jméno"
                className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl border border-white/25 bg-white/10 text-white transition hover:bg-white/20 sm:h-9 sm:w-9">
                <Pencil className="h-4 w-4" />
              </button>
            )}
          </div>
          <div className="flex shrink-0 items-center gap-2">
            {polozkyMenu.length > 0 && <NabidkaAkci polozky={polozkyMenu} tmava />}
            {onZavrit && (
              <button type="button" onClick={onZavrit} aria-label="Zavřít" title="Zavřít (Esc)"
                className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl border border-white/25 bg-white/10 text-white transition hover:bg-white/20 sm:h-9 sm:w-9">
                <X className="h-5 w-5" />
              </button>
            )}
          </div>
        </div>
        <div className="space-y-4">
          {k.blacklist && <Oznameni ton="problem"><b>BLACKLIST, nikdy nekontaktovat.</b></Oznameni>}
          {/* 8. 10. 2026 (mockup „Ozvala se znovu“): pruh, dokud s ní sales po nové poptávce nic neudělala. */}
          {k.znovu && k.znovu.nevyrizeno && (
            <Oznameni ton="pozor" ikona={RotateCcw}>
              <b>Ozvala se znovu {dm(k.znovu.datum)}{k.znovu.zdroj_text ? ` přes ${k.znovu.zdroj_text}` : ""}.</b>
              {` U nás je od ${dmr(k.znovu.prvni)}${k.znovu.prvni_zdroj ? ` (${k.znovu.prvni_zdroj})` : ""}`}{k.znovu.predtim ? <>, předtím: <b>{k.znovu.predtim}</b></> : ""}. Dotazník je nový, historie níž.
              {k.znovu.poptavky?.length > 1 && (
                <div className="mt-1 text-[12px] opacity-80">Poptávky: {k.znovu.poptavky.map((p, i) => <span key={i}>{i > 0 && <span className="mx-1.5 opacity-50">|</span>}{dmr(p.datum)} {p.zdroj}</span>)}</div>
              )}
            </Oznameni>
          )}
          {k.archiv
            ? <ArchivBlok k={k} onVratit={jeOwner ? zArchivu : null} prace={vraci} />
            : k.zaplaceno_bez_terminu
            ? <ZaplacenoBezTerminu z={k.zaplaceno_bez_terminu} onVybrat={() => window.open(k.zaplaceno_bez_terminu.odkaz, "_blank", "noopener")} onDotaznik={() => setDialog("dotaznik")} />
            : <Banner k={k} />}
          <div className="flex flex-wrap gap-1.5">
            <StavPilulka k={k} />
            <Pil ton="neutralni" casti={[k.zdroj || "neznámý zdroj", k.vytvoreno ? dm(k.vytvoreno) : ""]} />
            {k.znovu && <Pil ton="pozor" ikona={RotateCcw} casti={["Znovu poptala", dm(k.znovu.datum)]} />}
          </div>
          {k.telefon && (uzka
            ? <a href={telHref} className="btn-primary w-full !min-h-[56px] !text-base"><Phone className="h-5 w-5" />Zavolat {telefonHezky(k.telefon)}</a>
            : (
              <div className="flex flex-wrap items-center gap-3">
                <a href={telHref} className="text-2xl font-bold tabular-nums text-slate-900 hover:text-brand-deep">{telefonHezky(k.telefon)}</a>
                <button type="button" className="btn-ikona" onClick={kopiruj} aria-label="Kopírovat číslo" title="Kopírovat číslo"><Copy className="h-4 w-4" /></button>
                <span className="text-sm text-slate-500">volá z mobilu</span>
              </div>
            ))}
          {k.email && <div className="flex items-center gap-2 text-[15px] text-slate-600 [overflow-wrap:anywhere]"><Mail className="h-4 w-4 shrink-0 text-slate-400" />{k.email}</div>}

          {k.klientka && <SpolupraceKlientky klientka={k.klientka} />}
          {/* 22. 10. 2026 (Láďa): nedorazila na zkušební. S omluvou sales nastaví, kdy zavolat;
              bez omluvy je kontakt v NQ lead. Obojí jde později změnit. */}
          {k.nedorazila && (
            <Oznameni ton={k.nedorazila.omluva ? "pozor" : "problem"} ikona={UserMinus}>
              <b>Nedorazila na zkušební {dm(k.nedorazila.zkusebni)}{k.nedorazila.trener ? ` (trenér ${k.nedorazila.trener})` : ""}, {k.nedorazila.omluva ? "omluvila se." : "bez omluvy."}</b>
              {k.nedorazila.poznamka ? <> „{k.nedorazila.poznamka}“</> : null}
              <div className="mt-1 text-[12px] opacity-80">Zapsal(a) {k.nedorazila.kdo}{k.nedorazila.kdy ? ` ${kdyUdalost(k.nedorazila.kdy).den} ${kdyUdalost(k.nedorazila.kdy).cas}` : ""}. {k.nedorazila.omluva ? "Domluv s ní nový termín zkušebního." : "Kontakt je v NQ lead, nekontaktujeme ho."}</div>
              <div className="mt-2 flex flex-wrap items-center gap-2">
                {k.nedorazila.omluva && !k.dalsi && <button type="button" className="btn-primary btn-sm" onClick={() => setDialog("jindy")}><CalendarClock className="h-4 w-4" />Nastavit, kdy zavolat</button>}
                {!k.nedorazila.neuhrazeno && <button type="button" className="btn-secondary btn-sm" onClick={() => setDialog("nedorazila")}><RotateCcw className="h-4 w-4" />{k.nedorazila.omluva ? "Změnit na bez omluvy" : "Změnit na s omluvou"}</button>}
              </div>
              <div className="mt-1.5 text-[12px] opacity-80">{k.nedorazila.neuhrazeno ? "Zkušební nebyl zaplacený, faktura je stornovaná. Kontakt zůstává v NQ lead." : k.nedorazila.omluva ? "Ukázalo se, že se neomluvila? Změň to tlačítkem výš." : "Omluvila se později? Změň to tlačítkem výš, kontakt se vrátí k volání."}</div>
            </Oznameni>
          )}

          {!k.blacklist && otevreny && (
            <div className="space-y-2">
              <div className="text-xs font-semibold uppercase tracking-wide text-slate-500">Jak dopadl hovor?</div>
              {/* Zaplaceno bez termínu: „Zvedla“ nahrazuje tlačítko Vybrat termín v rámečku nahoře,
                  Nezvedla, Zavolat jindy a Nemá zájem zůstávají (audit 20. 10. 2026). */}
              {k.zaplaceno_bez_terminu ? null : k.klientka?.navrat_mozny
                ? <button type="button" className="btn w-full bg-emerald-600 !min-h-[56px] !text-base text-white hover:bg-emerald-700" onClick={() => setDialog("navrat")}><PhoneIncoming className="h-5 w-5" />Zvedla, domluvit návrat</button>
                : <button type="button" className="btn w-full bg-emerald-600 !min-h-[56px] !text-base text-white hover:bg-emerald-700" onClick={() => setDialog("hovor")}><PhoneIncoming className="h-5 w-5" />Zvedla, začít hovor</button>}
              <div className="grid grid-cols-3 gap-2">
                <button type="button" className="btn-secondary !min-h-[64px] !flex-col !gap-1 !px-1 !text-[14px] lg:!min-h-[44px] lg:!flex-row lg:!gap-2" onClick={() => setDialog("nezvedla")}><PhoneMissed className="h-5 w-5 lg:h-4 lg:w-4" />Nezvedla</button>
                <button type="button" className="btn-secondary !min-h-[64px] !flex-col !gap-1 !px-1 !text-[14px] lg:!min-h-[44px] lg:!flex-row lg:!gap-2" onClick={() => setDialog("jindy")}><CalendarClock className="h-5 w-5 lg:h-4 lg:w-4" />{k.stav === "novy" && !k.pokus ? "Naplánovat hovor" : "Zavolat jindy"}</button>
                <button type="button" className="btn border border-rose-300 bg-white text-rose-700 !min-h-[64px] !flex-col !gap-1 !px-1 !text-[14px] lg:!min-h-[44px] lg:!flex-row lg:!gap-2" onClick={() => setDialog("nezajem")}><UserX className="h-5 w-5 lg:h-4 lg:w-4" />Nemá zájem</button>
              </div>
            </div>
          )}
          {!k.blacklist && zk && zk.lze_nedorazila && !k.nedorazila && (
            <button type="button" className="btn border border-rose-300 bg-white text-rose-700 w-full !min-h-[52px]" onClick={() => setDialog("nedorazila")}><UserMinus className="h-4 w-4" />Nedorazila na zkušební</button>
          )}
          {!k.blacklist && zk && !zk.probehl && !zk.faktura && !zk.zaplaceno && (
            <button type="button" className="btn-primary w-full !min-h-[52px]" onClick={() => { setZkDialog(zk); setDialog("faktura"); }}><Receipt className="h-4 w-4" />Vystavit fakturu za zkušební</button>
          )}
          {!k.blacklist && zk && !zk.probehl && (
            <div className="grid gap-2 sm:grid-cols-2">
              <button type="button" className="btn-secondary !min-h-[52px]" onClick={() => { setZkDialog(zk); setDialog("presun"); }}><CalendarClock className="h-4 w-4" />Přesunout termín</button>
              <button type="button" className="btn border border-rose-300 bg-white text-rose-700 !min-h-[52px]" onClick={() => { setZkDialog(zk); setDialog("zrusit"); }}><CircleX className="h-4 w-4" />Zrušit zkušební</button>
            </div>
          )}
          {/* 7. 10. 2026 (#139): owner, manažer a CSM mají blok Výsledek (Deal, Prohra, NQlead, Zpět do
              Kvalifikace), Založit klientku je v něm. Sales má jen Vrátit k volání. */}
          {!k.blacklist && maVysledek && <VysledekLeadu k={k} onZmena={(r) => { if (r?.prohra) setNabidnoutEmail(true); nacti(); onZmena?.(); }} />}
          {/* 1. 11. 2026 (zadání 5, mockup 5C): neuzavřela po zkušebním, email s nabídkou bootcampu a Klubu. */}
          {!k.blacklist && k.stav === "neuzavreno" && <NeuzavrenoEmailBlok lead={k} otevrit={nabidnoutEmail} onOtevreno={() => setNabidnoutEmail(false)} onZmena={() => { nacti(); onZmena?.(); }} />}
          {!k.blacklist && !maVysledek && <ZalozitKlientku k={k} onHotovo={() => { nacti(); onZmena?.(); }} />}
          {!k.blacklist && !maVysledek && !otevreny && !zk && !k.nedorazila && (
            <button type="button" className="btn-secondary w-full" onClick={kVolani}><RotateCcw className="h-4 w-4" />Vrátit k volání</button>
          )}

          <SkupinaNadpis prava={k.vytvoreno && <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border border-brand-200 bg-white px-2.5 py-1 text-[12px] font-bold text-slate-600"><CalendarDays className="h-3.5 w-3.5 text-slate-400" />přišla {dm(k.vytvoreno)}</span>}>Z dotazníku</SkupinaNadpis>
          <div className="grid grid-cols-2 gap-2 lg:grid-cols-3">
            <DotTile popisek="Kdy chce začít" hodnota={d.kdy_zacit} />
            <DotTile popisek="Délka spolupráce" hodnota={d.delka} />
            <DotTile popisek="Kolikrát týdně" hodnota={d.frekvence} />
            <DotTile popisek="Kdy může" hodnota={d.kdy_muze} />
            <DotTile popisek="Lokalita" hodnota={d.lokalita} />
            <DotTile popisek="Zkušenosti" hodnota={d.zkusenosti} />
          </div>

          <SkupinaNadpis>Cíl a zdraví, uvidí i trenér</SkupinaNadpis>
          {zVyplneno ? (
            <div className="grid grid-cols-2 gap-2 lg:grid-cols-3">
              <DotTile popisek="Cíl" hodnota={z.cil} cely />
              <DotTile popisek="Zdravotní omezení" hodnota={z.zdravotni} />
              <DotTile popisek="Zranění" hodnota={z.zraneni} />
              <DotTile popisek="Chronické bolesti" hodnota={z.bolesti} />
              <DotTile popisek="Poznámky" hodnota={z.poznamky} cely />
            </div>
          ) : (
            <div className="flex flex-wrap items-center gap-2 rounded-xl border border-dashed border-slate-300 bg-white/60 px-3 py-2.5">
              <span className="text-xs font-bold text-slate-500">Vyplní se při hovoru</span>
              {["Cíl", "Zdravotní omezení", "Zranění", "Chronické bolesti", "Poznámky"].map((l) => <span key={l} className="rounded-full bg-slate-100 px-2.5 py-1 text-[12px] font-bold text-slate-600">{l}</span>)}
            </div>
          )}

          <KomentareKontaktu leadId={k.id} initial={k.komentare} onChanged={nacti} />

          <SkupinaNadpis>Historie</SkupinaNadpis>
          <div className="space-y-3.5">
            {k.historie.length ? k.historie.map((h, i) => <Udalost key={`${h.id}-${i}`} h={h} />) : <div className="text-sm text-slate-500">Zatím nic.</div>}
          </div>
        </div>
      </div>

      {jeOwner && (
        <>
          <LeadNejdeSmazatDialog open={!!nejdeSmazat} jmeno={k.jmeno} duvod={nejdeSmazat} onClose={() => setNejdeSmazat("")}
            onArchivovat={archivovat} onTestovaci={() => { setNejdeSmazat(""); setDialog("smazat_test"); }} />
          <SmazatTestovaciDialog leadId={k.id} open={dialog === "smazat_test"} onClose={() => setDialog(null)} onSmazano={poSmazaniTestovaciho} />
        </>
      )}
      <NezvedlaDialog lead={k} open={dialog === "nezvedla"} onClose={() => setDialog(null)} onHotovo={hotovo} />
      <JindyDialog lead={k} open={dialog === "jindy"} onClose={() => setDialog(null)} onHotovo={hotovo} />
      <NezajemDialog lead={k} open={dialog === "nezajem"} onClose={() => setDialog(null)} onHotovo={hotovo} />
      <OpravitJmenoDialog lead={k} open={dialog === "jmeno"} onClose={() => setDialog(null)} onHotovo={hotovo} />
      <DotaznikDialog lead={k} open={dialog === "dotaznik"} onClose={() => setDialog(null)} onHotovo={hotovo} />
      <NedorazilaDialog open={dialog === "nedorazila"} polozka={{ id: (k.nedorazila && k.nedorazila.zkusebni_id) || (zk && zk.id), jmeno: k.jmeno, neuhrazeno: !k.nedorazila && !!zk?.neuhrazeno }}
        vychozi={k.nedorazila ? (k.nedorazila.omluva ? "bez" : "omluva") : ""} onClose={() => setDialog(null)} onHotovo={hotovoPoNacteni}
        uloz={(telo) => salesPost("nedorazila", { ...telo, lead_id: k.id })} />
      {dialog === "hovor" && (
        <HovorPruvodce kontakt={k} open onClose={() => { setDialog(null); nacti(); onZmena?.(); }}
          onJindy={() => setDialog("jindy")} onNezajem={() => setDialog("nezajem")} />
      )}
      {dialog === "navrat" && <NavratDialog kontakt={k} open onClose={() => { setDialog(null); nacti(); onZmena?.(); }} onSeZkusebnim={() => setDialog("hovor")} />}
      {/* Seznam se obnoví až po zavření dialogu, ať výsledek kroků nezmizí pod rukama. */}
      {zkDialog && <PresunDialog z={zkDialog} open={dialog === "presun"} onClose={() => { setDialog(null); onZmena?.(); }} onHotovo={() => nacti()} />}
      {zkDialog && <ZrusitDialog z={zkDialog} open={dialog === "zrusit"} onClose={() => { setDialog(null); onZmena?.(); }} onHotovo={async () => { await nacti(); onZmena?.(); }} />}
      {zkDialog && <FakturaDialog z={zkDialog} open={dialog === "faktura"} onClose={() => { setDialog(null); onZmena?.(); }} onHotovo={() => nacti()} />}
    </div>
  );
}
